<template>
	<div class="internalLoder">
		<div class="loginLoader" v-if="pageloader_value">
			<div class="loader-info" v-if="type == 'complete'">
				<div class="spinner-border text-success" role="status">
				  <span class="sr-only">Loading...</span>
				</div>
			</div>
			<div v-if="type == 'table'">
				<div :colspan="colspan" class="loadingElement">
					<div class="loader-info">
						<div class="spinner-border text-success" role="status">
						  <span class="sr-only">Loading...</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<div class="pageloader_value" v-else-if="(!pageloader_value)">
			<div class="loader-info" v-if="type == 'complete'">
				<p class="text-center">
				<img src="../../../../static/fxView/images/no-record-icon.png" alt="Icon">
				<span class="oops">oops!</span> there is no record
			   </p>
			</div>
			
			<div class="inno-record" v-if="type == 'table' && list != '' && list.totalRecords == 0">
				<div :colspan="colspan">
					<div class="no_datafound text-center">
						<img src="../../../../static/fxView/images/no-record-icon.png" alt="Icon">
			            <p class="text-center"><span class="oops">oops!</span> there is no record</p>
			        </div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'LoaderComponent',
		data() {
			return { }
		},
		props:['pageloader_value','type','colspan','list','pageName']
	}
</script>


// WEBPACK FOOTER //
// src/components/fxView/shared/loader_component.vue